export default __webpack_public_path__ + "static/media/redmiles.03a64a16.jpeg";